import Snackbar from "@mui/material/Snackbar";
import { styled } from "@mui/material/styles";
import { palette, visibleViewport } from "../../../theme";

export const StyledSnackbar = styled(Snackbar, {
  shouldForwardProp: prop => prop !== "status",
})<{ status?: string }>(({ theme, status = "info" }) => ({
  /*
   * Offsets are measured from the visible band, not from the frame: pinned to
   * the top of an oversized host frame, a toast lands behind the host's own
   * header as soon as the host page is scrolled — measured at 56px in a viewport
   * whose first visible row was 120px, so it never appeared at all. Every
   * `visibleViewport` term is 0 (or the full viewport) while the app owns its
   * viewport.
   */
  "&&": {
    position: "fixed",
    left: "50%",
    right: "auto",
    top: `calc(${visibleViewport.top} + ${theme.spacing(3)})`,
    bottom: "auto",
    transform: "translateX(-50%)",
    maxWidth: `calc(100% - ${theme.spacing(4)})`,
    maxHeight: `calc(${visibleViewport.height} - ${theme.spacing(6)})`,
    zIndex: theme.zIndex.snackbar + 1,
    [theme.breakpoints.down("sm")]: {
      right: "auto",
      top: `calc(${visibleViewport.top} + ${theme.spacing(2)})`,
      maxWidth: `calc(100% - ${theme.spacing(2)})`,
      maxHeight: `calc(${visibleViewport.height} - ${theme.spacing(4)})`,
    },
  },
  "& .MuiPaper-root": {
    maxWidth: "100%",
    maxHeight: "inherit",
    overflowX: "hidden",
    overflowY: "auto",
    boxSizing: "border-box",
    backgroundColor:
      status === "success"
        ? palette.success
        : status === "error"
          ? palette.error
          : status === "warning"
            ? palette.warning
            : palette.info,
  },
  "& .MuiSnackbarContent-message": {
    minWidth: 0,
    maxWidth: "100%",
  },
}));
